export default __webpack_public_path__ + "static/media/logo.88d4a267.jpg";